<template>
    <div class="bonus-container">
        <div class="section-title">{{ $t('your bonus') | capitalize }}</div>
        <div
            class="amount-container"
            v-if="typeof amount === 'number'"
        >
            <div :class="amountClass">{{ amount | twoDecimals }}</div>
            <div class="currency">{{ $t('currencyAbbreviation') }}</div>
        </div>
        <div v-else>
            -
        </div>
        <SubtleLinkExternal link="https://suport.superbet.ro/hc/ro/sections/360000069665-Bonusuri">
            {{ $t('Frequently Asked Questions - Bonuses') }}
        </SubtleLinkExternal>
    </div>
</template>

<script>
    import { staticlink } from '@shared/filters';


    export default {
        name: 'Bonus',
        props: {
            amount: {
                type: Number,
                required: false,
                default: null
            }
        },
        created() {
            this.staticlink = staticlink;
        },
        computed: {
            amountClass() {
                return {
                    amount: true,
                    dark: this.amount > 0,
                };
            },
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/userProfile/components/Bonus.vue